<template>
  <div class="RwvContentPdfEdit">
    <b-form-group
      :id="'input-group-title-' + index"
      :label-for="'input-title-' + index"
      v-b-tooltip.hover
      title="Titel der PDF">
      <b-form-input
        :id="'input-title-' + index"
        v-model="data.title"
        required
        placeholder="Titel">
      </b-form-input>
    </b-form-group>

    <b-form-group
      :id="'input-group-upload-pdf-file-' + index"
      :label-for="'input-upload-pdf-file-' + index"
      v-b-tooltip.hover
      title="PDF-Datei">
      <b-form-file
        :id="'input-upload-pdf-file-' + index"
        @change="selectedPdf"
        accept="pdf"
        placeholder="PDF auswählen ..."
        drop-placeholder="Datei hierher ziehen ...">
      </b-form-file>
    </b-form-group>

    <div class="text-center my-4" v-if="uploading">
      <b-spinner label="Spinning"></b-spinner> Aktualisieren
    </div>
  </div>
</template>

<script>
import { singleUpload } from "@/common/aws.service";
export default {
  name: "RwvContentPdfEdit",
  props: {
    data: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    postSlug: {
      type: String
    }
  },
  data() {
    return {
      uploading: false
    }
  },
  methods: {
    selectedPdf(pdf) {
      var me = this
      this.uploading = true
      singleUpload(pdf.target.files[0], this.postSlug, "pdf").then(function(location) {
        me.uploading = false
        me.data.pdfLink = location
        // me.$emit('changed', me.cropImg, me.index)
      })
    }
  }
};
</script>
